<template>
    <button v-if="isTrueValue" type="button" class="btn btn-tool" :title="currentValue.desFunction" @click="onClickFunction">
        <i :class="currentValue.icon" :style="{ color: currentValue.iconColor }"></i>
    </button>
</template>

<script>
import $ from 'jquery'
import objectDefaultValue from '@/config/object.env'
import i18n from '@/helper/i18n'
export default {
    name: "TheSwapButton",
    props: {
        modelValue: {
            type: [Number],
            default: null,
        },
    },
    data() {
        return {
            localValue: this.modelValue,
            swapCurrentList: {
                title: this.$t('buttons.swapCurrentList'),
                desFunction: this.$t('buttons.swapDeletedList'),
                icon: 'far fa-list-alt',
                iconColor: '#df132e',
            },
            swapDeletedList: {
                title: this.$t('buttons.swapDeletedList'),
                desFunction: this.$t('buttons.swapCurrentList'),
                icon: 'far fa-list-alt',
                iconColor: '#28a745',
            },
            currentValue: {
                title: '',
                desFunction: '',
                icon: '',
                iconColor: '',
            },
            typeDataList: objectDefaultValue.TYPEDATA_LIST,
            isTrueValue: true,
        };
    },
    methods: {
        onClickFunction() {
            if (this.localValue === this.typeDataList.DELETED_LIST.id) {
                this.localValue = this.typeDataList.CURRENT_LIST.id;
                this.currentValue = this.swapDeletedList
            } else if (this.localValue === this.typeDataList.CURRENT_LIST.id) {
                this.localValue = this.typeDataList.DELETED_LIST.id;
                this.currentValue = this.swapCurrentList
            }
            this.$emit('update:modelValue', this.localValue);
            this.$emit('button-clicked', this.localValue);
        }
    },

    watch: {
        modelValue: {
            immediate: true,
            handler(newValue) {
                if (this.modelValue === this.typeDataList.DELETED_LIST.id) {
                    this.currentValue = this.swapDeletedList
                } else if (this.modelValue === this.typeDataList.CURRENT_LIST.id) {
                    this.currentValue = this.swapCurrentList
                }
            }
        }
    },
    mounted() {
        if (this.modelValue === this.typeDataList.DELETED_LIST.id) {
            this.currentValue = this.swapDeletedList;
        } else if (this.modelValue === this.typeDataList.CURRENT_LIST.id) {
            this.currentValue = this.swapCurrentList;
        } else {
            this.isTrueValue = false;
        }
    },
};
</script>

<style></style>
